import React from "react";
import PropTypes from "prop-types";
import styles from "./MembershipAddressItem.module.css";
import { ChevronRight } from "react-ikonate";
import { useTranslation } from "react-i18next";

export function MembershipAddressItem({ onClick }) {
  const {t} = useTranslation();
  return (
    <div className={styles.noInfoContainer}>
      <span className={styles.header}>{t("Default Address")} </span>
      <div className={styles.cardInfo}>
        <div className={styles.noBillingMethodMessage}>
          <div>{t("Please select a default address")}</div>

          <div>
            <ChevronRight className={styles.dropdownArrow} onClick={onClick} />
          </div>
        </div>
      </div>
    </div>
  );
}

MembershipAddressItem.propTypes = {
  onClick: PropTypes.func,
};

export default MembershipAddressItem;
